import { FieldModel } from '@cibo/core'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'react-i18next'

type FieldCropTypeColumnParams = {
  t: TFunction
  year: number
} & Partial<GridColDef<FieldModel>>

export const fieldCropTypeColumn = ({ t, year, ...params }: FieldCropTypeColumnParams) =>
  ({
    field: `cashCrop${year}`,
    flex: 1,
    headerName: t('headerCropTypeYear', { year, ns: '@cibo/landmanager/FieldColumns' }),
    minWidth: 200,
    renderCell: ({ value }: GridRenderCellParams<string | undefined>) =>
      !!value ? t(value, { ns: '@cibo/ui/cropNames' }) : '-',
    resizable: false,
    sortable: false,
    valueGetter: ({ row }) => row.resolveStandingDetail('cashCrop', year)?.result,
    ...params,
  } as GridColDef<FieldModel>)
